import React, { useState, useCallback, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import "../RerouteModal/RerouteModalStyles.css";
import { getRerouteUser, routeBackToExpert } from "../../../API/api";
import { toast } from "react-toastify";
import { RetweetOutlined } from "@ant-design/icons";
import { Select } from 'antd';
import MultiSelectCm from "../../MultiSelectCm/MultiSelectCm";
import { QrCodeScannerOutlined } from "@mui/icons-material";
import Styles from './RouteBack.module.css'
import {ReactComponent as ShareIcon} from '../../../Icons/share.svg'

const modalTitleStyle = {
    color: "rgb(42, 54, 74)",
    fontSize: "20px",
    fontFamily: "Helvetica",
  };
export default function RouteBackToExpert() {
    const [isLoading, isLoaded] = useState(false);
    const cmState = useSelector((state) => state.cmRoot);
    const [options, setOptions] = useState(cmState.routingData);
    const [selectedExpert, setSelectedExpert] = useState([]);
    const successMsg = (message) => {
        return (
            <>
                <span style={{ fontSize: "12px" }}>{message}</span>
            </>
        );
    };
    // const getExperts =()=>{
    //     getRerouteUser().then((res) => {
    //         if (res.data.success) {
    //           let updatedData = res.data.data.users.filter((exp) => {
    //             exp.label = exp.firstName + " " + exp.lastName;
    //             exp.value = exp.userUuid;
    //             exp.name = exp.firstName + " " + exp.lastName;
    //             return exp;
    //           });
    //           setOptions(updatedData);
    //         }
    //       });
    // }
    const modalState = useSelector((state) => state.domain);
    const expertRecordsState = useSelector((state) => state.expertRecord);
    const dispatch = useDispatch();
    const { advanceFilterModalToggle, cmrRefreshPage, cmrClickedData } = bindActionCreators(Actions, dispatch);
    const onClickButtons = () => {
        isLoaded(true);
        let answerUuids = expertRecordsState.clickedData.map(obj => {
            return obj.questionUuid
        })
        let payload = {
            'levelId': selectedExpert.id,
            'questionId': answerUuids.toString()
        }
        routeBackToExpert(payload).then(res => {
            if (res === undefined) return;
            if (res.data.success) {
                toast.success(successMsg(res.data.message));
                cmrRefreshPage(1234567);
                cmrClickedData(null);
                advanceFilterModalToggle({ bool: false, value: "" });
                isLoaded(false);
            } else {
                cmrRefreshPage(1234567);
                cmrClickedData(null);
                advanceFilterModalToggle({ bool: false, value: "" });
                isLoaded(false);
            }
        }).catch(err => {
            advanceFilterModalToggle({ bool: false, value: "" });
            isLoaded(false);
        })
    }
    const onChangeSelectedOption = (value) => {
        const result =options.find(item => item.label === value.label && item.value === value.value);
        setSelectedExpert(result);
    };
    useEffect(() => {
        // getExperts();
    }, [])

    // console.log("selectedExpert",selectedExpert)
    return (
        <>
            {/* <Modal show={modalState.modalState}
            onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
            centered={true}
            size={"lg"}
            style={{marginTop:"-50px"}}
            // scrollable={true}
        >
            <ModalHeader className="reroutetitleModal" closeButton closeVariant="white">
                <ModalTitle>
                    <h5 className="headingModal" style={{display:'flex',alignItems:'center',marginBottom:'0px'}}><RetweetOutlined style={{ paddingRight: "7px", fontSize: "24px" }}/>Reroute Questions</h5>
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                <div className="row" style={{paddingLeft:'1.5rem',paddingRight:'1.5rem',paddingBottom:'5px', textAlign:'center'}}>
                    <div className="container">
                        <p style={{fontSize:'16px', marginBottom:'5px'}}>Are you sure you want to Re-Route the selected Question(s)?</p>
                        <div className="mb-2">
                            <span style={{fontSize:'14px'}}>Select level from which rerouting should start</span>
                            <br/>
                            <div className="mt-2" style={{display:'flex', justifyContent:'center'}}>
                            <MultiSelectCm value={selectedExpert} onChangeFunc={onChangeSelectedOption} disabled={false} options={options} isMulti={false}  />
                            </div>
                        </div>
                        {!isLoading && <div>
                            <button className="cancelBtn" onClick={()=>advanceFilterModalToggle({ bool: false, value: "" })}>Cancel</button>&nbsp;<button className="rerouteBtn" disabled={selectedExpert.length === 0 }  onClick={()=>onClickButtons()}>Submit</button></div>}
                        {isLoading && 
                        <div>
                            <button className="loadingpublishbutton" disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Transferring</button>
                        </div>}
                    </div>
                </div>
            </ModalBody>
        </Modal> */}
            <Modal
                show={modalState.modalState}
                onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
                centered={true}
                size={"lg"}
            // dialogClassName={styles.modalDialog}
            >
                <Modal.Header closeButton>
                    <Modal.Title style={modalTitleStyle}>
                        {/* <i className="fa fa-files-o"></i> */}
                        {/* &nbsp;&nbsp;  */}
                        <span style={{ display: "flex", alignItems:"center" }}><ShareIcon style={{fontSize:"22px"}}/> &nbsp;&nbsp;
                        <span style={{display:"flex",justifyContent:"center"}}>
                        Reroute Questions
                        </span>

                        </span>


                        {/* <i className="fa fa-files-o"></i> &nbsp;&nbsp;Data Export */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={Styles.mainBodyContent}>
                        <h2>Are you sure you want to Re-Route the selected Question(s)?</h2>
                    </div>
                    <div className={Styles.mainBodyContent}>
                        <h2>Select level from which rerouting should start</h2>
                    </div>
                    <div className={Styles.mainBodyContent}>
                        {/* <Select
                            size="medium"
                            mode="multiple"
                            allowClear={true}
                            popupClassName={Styles.selectCss}
                            options={options}
                            style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}
                            placeholder="Select Expert"
                            // value={expert}
                            // onChange={changeExpert}
                            // disabled={disabled}
                            optionLabelProp="label"
                            filterOption={(input, option) =>
                                option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                            value={selectedExpert}
                            onChangeFunc={onChangeSelectedOption}

                            dropdownStyle={{ textAlign: "left" }}
                            maxTagCount={0}
                            maxTagPlaceholder={`${selectedExpert?.length || 0} selected`}
                        // allowClear={true}
                        /> */}
                            {/* <MultiSelectCm value={selectedExpert} onChangeFunc={onChangeSelectedOption} disabled={false} options={options} isMulti={false}  /> */}

                        <Select
                            labelInValue
                            value={selectedExpert}
                            defaultValue={{
                                "autoId": 3,
                                "groupId": 1,
                                "id": 3,
                                "name": "global",
                                "timeoutPeriod": 1515,
                                "abortPeriod": 1586,
                                "createdBy": null,
                                "createdDate": null,
                                "modifiedDate": null,
                                "maxExpert": 2,
                                "value": "global",
                                "label": "Global"
                            }}
                            onChange={onChangeSelectedOption}
                            disabled={false}
                            placeholder="Select Level"
                            onChangeFunc={onChangeSelectedOption}
                            options={options}
                            popupClassName={Styles.selectCss}
                            showSearch
                            filterOption={(input, option) =>
                              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            size="middle"
                            style={{ width: "18%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}

                        />
                    </div>  
                    <div style={{textAlign:"center"}}>
                        {
                            !isLoading && <>
                                <button
                                    style={{
                                        padding: '8px 12px 8px 12px',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        lineHeight: '24px',
                                        fontWeight: 400,
                                        boxShadow: ' 0px 1px 2px 0px #1018280D',
                                        color: '#2A364A',
                                        border: '1px solid  #fff',
                                        height: '40px',
                                        minWidth: '88px',
                                        background: " #F6F7F8",
                                        marginBottom: '14px',
                                        fontWeight: 400,
                                        border: " 1px solid #E0E2E6"

                                        //  font-weight: 400;           
                                    }}
                                    onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}
                                //  onClick={() => setEdit(false)}
                                >
                                    Cancel
                                </button>
                                &nbsp;&nbsp;
                                <button
                                    style={{
                                        padding: '8px 12px 8px 12px',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        lineHeight: '24px',
                                        fontWeight: 400,
                                        boxShadow: '0px 1px 2px 0px #1018280D',
                                        color: '#FFFFFF',
                                        border: '1px solid  #fff',
                                        height: '40px',
                                        minWidth: '88px',
                                        background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                        marginBottom: '14px',
                                        marginTop: "15px",
                                        cursor:selectedExpert.length === 0?"not-allowed":"pointer",
                                        opacity:selectedExpert.length === 0?"0.7":"",
                                    }}
                                    disabled={selectedExpert.length === 0?true:false } 
                                    onClick={() => onClickButtons()}
                                >
                                    Submit
                                </button>
                            </>
                        }
                        {isLoading &&
                            <div>
                                <button
                                    style={{
                                        padding: '8px 12px 8px 12px',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        lineHeight: '24px',
                                        fontWeight: 400,
                                        boxShadow: '0px 1px 2px 0px #1018280D',
                                        color: '#FFFFFF',
                                        border: '1px solid  #fff',
                                        height: '40px',
                                        minWidth: '88px',
                                        background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                        marginBottom: '14px',
                                        marginTop: "15px",
                                        cursor:"not-allowed",
                                        opacity:"0.7"
                                    }} disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Submit..</button>
                            </div>}
                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}